/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { ServerLinkStatusData } from './ServerLinkStatusData.types.tsx';

export const servicedeskKnowledgeBaseServerLinkStatusResource: RouteResource<ServerLinkStatusData> =
	createResource<ServerLinkStatusData>({
		type: 'SERVICEDESK_KNOWLEDGE_BASE_SERVER_LINK_STATUS',
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-knowledge-base-server-link-status", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-server-link-status" */ './GetDataGetData.tsx'
			),
		maxAge: 30 * 60 * 1000, // 30 minutes
	});
